import Api from './api';

export default {
  getFurnitureItems: (data) => Api.get('furniture', data),
  getFurnitureDetails: (id) => Api.get(`furniture/${id}`),
  getFurnitureCategories: () => Api.get('furniture/categories'),
  getFurnitureSales: (data) => Api.get('furniture/sales', data),
  updateFurniture: (id, data) => Api.post(`furniture/${id}`, data),
};
